import { SvgIcon } from "@material-ui/core";
import React from 'react';

export const ContactsIcon = (props: any) => {
  return (
    <SvgIcon {...props} width="14" height="18" viewBox="0 0 14 18">
      <path fill="currentColor" d="M13.462 2.51h-1.616V.916c0-.293-.241-.531-.538-.531H1.615C.725.385 0 1.1 0 1.978V15.26c0 1.172.966 2.125 2.154 2.125h11.308c.297 0 .538-.238.538-.532V3.041c0-.293-.241-.531-.538-.531zM9.154 14.197H3.769c-.297 0-.538-.238-.538-.531 0-1.465 1.208-2.656 2.692-2.656H7c1.484 0 2.692 1.19 2.692 2.656 0 .293-.24.531-.538.531zM4.308 7.822c0-1.172.966-2.125 2.154-2.125 1.187 0 2.153.953 2.153 2.125 0 1.172-.966 2.125-2.153 2.125-1.188 0-2.154-.953-2.154-2.125zm6.461-5.312H1.615c-.297 0-.538-.238-.538-.532 0-.293.241-.53.538-.53h9.154V2.51z"/>
    </SvgIcon>
  );
};